import gql from "graphql-tag";

export default gql`
  mutation DestroyAssetDiscussionCommentReply($replyId: ObjectID!) {
    destroyAssetDiscussionCommentReply(replyId: $replyId)
  }
`;
